import * as actionCreatorFactory from "typescript-fsa";

import { Action } from "typescript-fsa";
import { Moment } from "moment";

import { ApiRequest } from "@api/requests";
import { VendorNormalisedEntities } from "@vendor/models";
import { TrendsPaginationResult, StateError, NormalisedResult } from "@orm/models";
import * as actionTypes from "../constants";
import { SalesResponse, DemographicsResponse, HeadlineStatsResponse, PlaylistTrendsData } from "../models";

export type PlaylistTrendsResult = NormalisedResult<PlaylistTrendsData[], VendorNormalisedEntities>;

const actionCreator = actionCreatorFactory.default();

export const requestSalesGet = actionCreator<ApiRequest>(actionTypes.GET_REQUEST);
export const salesGetSuccess = actionCreator<SalesResponse>(actionTypes.GET_SUCCESS);
export const salesGetFailure = actionCreator<StateError>(actionTypes.GET_FAILURE);

export const requestDemographicsGet = actionCreator<ApiRequest>(actionTypes.DEMOGRAPHICS_GET_REQUEST);
export const demographicsGetSuccess = actionCreator<DemographicsResponse>(actionTypes.DEMOGRAPHICS_GET_SUCCESS);
export const demographicsGetFailure = actionCreator<StateError>(actionTypes.DEMOGRAPHICS_GET_FAILURE);

export const requestHeadlineStatsGet = actionCreator<ApiRequest>(actionTypes.HEADLINE_STATS_GET_REQUEST);
export const headlineStatsGetSuccess = actionCreator<HeadlineStatsResponse>(actionTypes.HEADLINE_STATS_GET_SUCCESS);
export const headlineStatsGetFailure = actionCreator<StateError>(actionTypes.HEADLINE_STATS_GET_FAILURE);

export const requestPlaylistTrendsGet = actionCreator<ApiRequest>(actionTypes.PLAYLIST_TRENDS_GET_REQUEST);
export const playlistTrendsGetSuccess = actionCreator<[TrendsPaginationResult, PlaylistTrendsResult]>(
    actionTypes.PLAYLIST_TRENDS_GET_SUCCESS,
);
export const playlistTrendsGetFailure = actionCreator<StateError>(actionTypes.PLAYLIST_TRENDS_GET_FAILURE);

export const toggleStreamsDownloads = actionCreator<{}>(actionTypes.STREAMS_DOWNLOADS_TOGGLE);

export const setDateRange = actionCreator<[Moment, Moment]>(actionTypes.DATE_RANGE_SET);

export const setCountries = actionCreator<string[]>(actionTypes.COUNTRIES_SET);

export const resetChartLegend = actionCreator<string[]>(actionTypes.CHART_LEGEND_RESET);
export const updatedChartLegend = actionCreator<[string, boolean]>(actionTypes.CHART_LEGEND_UPDATE);

export type SalesAction = Action<ApiRequest> | Action<{}> | Action<SalesResponse> |
    Action<DemographicsResponse> | Action<[Moment, Moment]> | Action<string[]> |
    Action<StateError>;
